import {
  Autocomplete,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  Input,
  InputAuto,
  InputDate,
  InputFile,
  InputQty,
  Select,
} from "../../controls";
import { Alert, Dialog, Form } from "../../layout";
import { DropLi, Model, UseForm } from "../../hooks";
import { Box } from "@mui/system";
import { useNavigate, useParams } from "react-router-dom";
import { ClearRounded } from "@mui/icons-material";
import * as actions from "../../api/actions/pos";
import { connect } from "react-redux";
import { controller, endpoints } from "../../api/actions/api";
import { useEffect } from "react";
import {
  MaxLength,
  NestedFormData,
  RmvArryEmptyProp,
} from "../../hooks/Method";
import AddEditProd from "../products/AddEditProd";  // here add a new product in purchase form
import { useContext } from "react";
import { AppContext } from "../../App";
import { safeOnComplete } from "../../utils/safeOnComplete";
import { formatCurrency } from "../../hooks/Currency";

const AddMultPurch = (props) => {
  const { t } = useTranslation();
  const { _post, _put, _getById, _store, _getByObj, _authUser } = props;
  const { PurchaseMdl } = Model();
  const navigate = useNavigate();
  const { setLoader } = useContext(AppContext);
  const { PaymentType } = DropLi();
  const {
    values,
    setValues,
    errors,
    setErrors,
    handleFile,
    handleInpChg,
    handleInpDate,
  } = UseForm(PurchaseMdl);

  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });
  const [searchVal, setSearchVal] = useState("");
  const [showPurchaseProductForm, setShowPurchaseProductForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [suppliers, setSuppliers] = useState([]);
  const [searchLi, setSearchLi] = useState([]);
  const [netAmount, setNetAmount] = useState(0);
  const [findErr, setFindErr] = useState("");

 // const [purchItems, setPurchItems] = useState([]);

  const { id } = useParams();

  useEffect(() => {
    // Set Focuse in Searchbox
    document.getElementById("searchBox").focus();

    if (_store.id) {
      const onComplete = (res) => {
        setLoader(false);
        res.status === 200 &&
          setSuppliers([
            ...res.result.map((j) => {
              return {
                id: j.id,
                label: `${j.firstName} ${j.lastName} (${j.phone})`,
              };
            }),
          ]);
      };
      setLoader(true);
      _getById(
        endpoints.Supplier + controller.GetByStore,
        _store.id,
        null,
        onComplete
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_store]);

  useEffect(() => {
    var netAmount = values.purchItems
      .map((j) => j.qty * j.purchPrice)
      .reduce((x, y) => x + y, 0);
    var discount = (parseFloat(values.discount || 0) / 100) * netAmount;
    setNetAmount((netAmount - discount).toFixed(2));
  }, [values, values.discount]);

  useEffect(() => {
    const onComplete = (res) => {
      res.status === 200 &&
        res.result.purchItems &&
        setValues({
          ...res.result,
          discount: res.result.discount || "",
          paymentDue: res.result.paymentDue || "",
          receipt: res.result.receipt || "",
        });
    };

    if (id && _store.id)
      _getByObj(
        endpoints.Purchase + controller.GetById,
        { id: id, storeId: _store.id },
        null,
        onComplete
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, _store.id]);

  const handlePurchForm = () => {
    setShowPurchaseProductForm((prev) => !prev);
  };

  const validateForm = () => {
    let temp = {};
    temp.supplierId = values.supplierId !== "" ? "" : t("supplierRequired");
    temp.paymentType =
      values.paymentType !== "" ? "" : t("paymentTypeRequired");

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = () => {
    if (validateForm() && values.purchItems.length > 0) {
      setLoading(true);

      const onComplete = (res, err) => {
      setLoading(false);

      if (err) {
        console.error("PURCHASE SAVE ERROR:", err);

        setAlert({
          isOpen: true,
          type: "error",
          title: t("error"),
          subTitle: err.message || t("purchaseCouldNotBeSaved"),
        });

        return;
      }

      if (res?.status === 201 || res?.status === 200) {
        _getById(
          endpoints.Purchase + controller.GetByStore,
          _store.id,
          actions.ActionType.List,
          () => navigate("/purchases")
        );
      } else {
        setAlert({
          isOpen: true,
          type: "error",
          title: "Error",
          subTitle: res?.msg || t("purchaseCouldNotBeSaved"),
        });
      }
    };
      values.userId = _authUser.id;

      if (id) {
        _put(
          endpoints.Purchase,
          NestedFormData(RmvArryEmptyProp(values)),
          null,
          onComplete
        );
      } else {
        values.storeId = _store.id;
        _post(
          endpoints.Purchase,
          NestedFormData(RmvArryEmptyProp(values)),
          null,
          onComplete
        );
      }
    } else if (values.purchItems.length <= 0)
      setAlert({
        isOpen: true,
        type: "error",
        title: t("emptyPurchaseList"),
        subTitle: t("emptyPurchaseListMessage"),
      });
  };

  const GetDataFromServer = (val, onComplete) => {
    // Get Data From Server
    val &&
      _getByObj(
        endpoints.Product + controller.FindProducts,
        {
          storeId: _store.id,
          value: val,
        },
        null,
        onComplete
      );
  };

  //
  const handleSearch = (e, val) => {
  setSearchVal(val);

  const onComplete = safeOnComplete(
    (res) => {
      if (res.status === 200 && Array.isArray(res.result)) {
        setSearchLi(
          res.result.map((j) => ({
            ...j,
            id: j.id,
            label: `${j.name} (${j.barcode})`,
          }))
        );
        setFindErr("");
      }
    },
    (err) => {
      setFindErr(err?.msg ?? t("searchFailed"));
    }
  );

  e && GetDataFromServer(e.target.value, onComplete);
};
  //
  //
const handleScan = (e) => {
  const value = e.target.value;

  const onComplete = safeOnComplete(
    (res) => {
      if (
        res.status === 200 &&
        Array.isArray(res.result) &&
        res.result.length > 0
      ) {
        handleSelect(null, res.result[0]);
      } else {
        setFindErr(t("productNotFound"));
      }
    },
    (err) => {
      setFindErr(err?.msg ?? t("productLookupFailed"));
    }
  );

  GetDataFromServer(value, onComplete);
  setSearchVal("");
};
  //

  const handleSelect = (e, product) => {
    if (product) {
      if (!values.purchItems.some((j) => j.productId === product.id)) {
        setValues((x) => ({
          ...x,
          purchItems: [
            {
              productId: product.id,
              qty: 1,
              purchPrice: product.purchPrice,
              product: product,
            },
            ...x.purchItems,
          ],
        }));
      } else if (values.purchItems.some((j) => j.productId === product.id)) {
        setValues((x) => ({
          ...x,
          purchItems: x.purchItems.map((j) =>
            j.productId === product.id ? { ...j, qty: parseInt(j.qty) + 1 } : j
          ),
        }));
      }
      setFindErr("");
    }
    setSearchVal("");
  };

  const handleQtyChg = (e, productId) => {
    setValues((x) => ({
      ...x,
      purchItems: x.purchItems.map((j) =>
        j.productId === productId ? { ...j, qty: Math.abs(e.target.value) } : j
      ),
    }));
  };

  const handleInc = (productId) => {
    setValues((x) => ({
      ...x,
      purchItems: x.purchItems.map((j) =>
        j.productId === productId ? { ...j, qty: parseInt(j.qty) + 1 } : j
      ),
    }));
  };
  const handleDec = (productId) => {
    setValues((x) => ({
      ...x,
      purchItems: x.purchItems.map((j) =>
        j.productId === productId
          ? { ...j, qty: j.qty > 1 ? parseInt(j.qty) - 1 : j.qty }
          : j
      ),
    }));
  };

  const handleRmvItem = (prodId) => {
    setValues((x) => ({
      ...x,
      purchItems: x.purchItems.filter((j) => j.productId !== prodId),
    }));
  };

  const handlePurchPrice = (e, productId) => {
    setValues((x) => ({
      ...x,
      purchItems: x.purchItems.map((j) =>
        j.productId === productId ? { ...j, purchPrice: e.target.value } : j
      ),
    }));
  };

  return (
    <>
      <Form noValidate>
        <Box className="tx-center p-20">
          <Typography variant="h5" className="fs-26 gray-color fw-5 tx-upp">
            {t("purchases")}
          </Typography>
          <div className="bs-bottom mx-w-80 mt-5 m-auto" />
        </Box>

        {/* Items */}
        <div className="pt-20" />
        <Paper className="br-8 shadow-xs p-20">
          {/* Title Bar */}
          <Box className="d-flex j-between">
            <Typography
              variant="subtitle1"
              className="fs-18 fw-5 gray-color pl-10 mb-20"
              sx={{ borderLeft: "5px double var(--primary-color)" }}
            >
              {t("purchaseProducts")}
            </Typography>
            <div>
              <Button size="small" onClick={handlePurchForm}>
                {t("addNewProduct")}
              </Button>
            </div>
          </Box>

          {/* Search Box */}
          <Autocomplete
            id="searchBox"
            options={searchLi}
            onChange={handleSelect}
            inputValue={searchVal}
            onInputChange={handleSearch}
            isOptionEqualToValue={(opt, val) => opt.id === val.id}
            onKeyDown={(e) => e.which === 13 && handleScan(e, searchVal)}
            classes={{ paper: "shadow-sm" }}
            renderInput={(params) => (
              <TextField
                variant="filled"
                label={t("searchByNameOrBarcode")}
                {...(findErr && { error: true, helperText: findErr })}
                {...params}
              />
            )}
          />

          {/* Product Details */}
          <TableContainer className="mt-20">
            <Table size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell>{t("action")}</TableCell>
                  <TableCell>{t("productName")}</TableCell>
                  <TableCell>{t("quantity")}</TableCell>
                  <TableCell>{t("purchasePrice")}</TableCell>
                  <TableCell>{t("subtotal")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {values.purchItems.map((prod, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <Tooltip arrow title={t("delete")}>
                        <IconButton
                          onClick={() => handleRmvItem(prod.productId)}
                          size="small"
                          className="btn-error"
                        >
                          <ClearRounded className="fs-14" />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                    <TableCell>{prod.product && prod.product.name}</TableCell>
                    <TableCell>
                      <InputQty
                        value={prod.qty}
                        onIncrease={() => handleInc(prod.productId)}
                        onDecrease={() => handleDec(prod.productId)}
                        onChange={(e) => handleQtyChg(e, prod.productId)}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        size="small"
                        type="number"
                        className="rmv-arrow"
                        value={prod.purchPrice}
                        sx={{
                          "& .MuiInputBase-root": {
                            maxWidth: "120px",
                            padding: "0px 0px",
                          },
                          "& .MuiInputBase-input": {
                            padding: "5.5px 0px",
                            textAlign: "center",
                          },
                        }}
                        onChange={(e) => handlePurchPrice(e, prod.productId)}
                      />{" "}
                    </TableCell>
                    <TableCell className="fs-16">
                      {formatCurrency(prod.qty * prod.purchPrice, _store)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Box className="tx-right p-10 tx-upp">
              <Typography className="fs-16 gray-color fw-5">
                {t("totalItem")}:&nbsp;
                {values.purchItems.length > 0
                  ? values.purchItems
                      .map((j) => j.qty)
                      .reduce((x, y) => x + y, 0)
                  : 0}
              </Typography>
              <Typography className="fs-20 gray-color fw-6">
                {t("netAmount")}: {formatCurrency(netAmount, _store)}
              </Typography>
            </Box>
          </TableContainer>
        </Paper>

        {/* Purchase Details */}
        <div className="pt-20" />
        <Paper className="br-8 shadow-xs p-20">
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <InputAuto
                label={t("supplier")}
                name="supplierId"
                options={suppliers}
                value={values.supplierId}
                error={errors.supplierId}
                onChange={handleInpChg}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <InputDate
                label={t("purchaseDate")}
                name="purchDate"
                value={values.purchDate}
                error={errors.purchDate}
                onChange={(date) =>
                  handleInpDate(
                    "purchDate",
                    new Date(date).toLocaleDateString()
                  )
                }
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Select
                label={t("paymentType")}
                name="paymentType"
                fullWidth
                value={values.paymentType}
                error={errors.paymentType}
                onChange={handleInpChg}
                options={PaymentType}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Input
                label={t("paymentDue")}
                className="rmv-arrow"
                name="paymentDue"
                type="number"
                onInput={(e) =>
                  (e.target.value = MaxLength(e.target.value, 12))
                }
                value={values.paymentDue}
                error={errors.paymentDue}
                onChange={handleInpChg}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Input
                label={t("discount")}
                type="number"
                onInput={(e) => (e.target.value = MaxLength(e.target.value, 3))}
                name="discount"
                className="rmv-arrow"
                value={values.discount}
                error={errors.discount}
                onChange={handleInpChg}
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {_store?.currencyCode || "USD"}
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InputFile
                label={t("uploadReceipt")}
                name="receiptFile"
                src={values.receipt}
                values={values.receipt}
                onChange={handleFile}
                rmv={() => {
                  setValues({ ...values, receiptFile: "", receipt: "" });
                }}
              />
            </Grid>
          </Grid>
        </Paper>

        <Grid item xs={12} className="tx-right mt-20">
          <Button
            loading={loading}
            onClick={handleSubmit}
            sx={{ width: { md: "200px", xs: "100%" } }}
            size="large"
          >
            {id ? t("saveChanges") : t("submit")}
          </Button>
        </Grid>
      </Form>
      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
      {/* Edit Dialog */}
      {showPurchaseProductForm  && (
        <Dialog open={showPurchaseProductForm} maxWidth="md" fullWidth>
          <AddEditProd 
          from="purchase" 
          setShowPurchForm={setShowPurchaseProductForm}
              
          // ✅ ADD THIS LINE
          onClose={() => setShowPurchaseProductForm(false)}

          onSaved={(product) => {
              console.log("Saved product from Purchase:", product);

              // ✅ You decide what to do here
              // Example: add to purchase list
             // setPurchItems((prev) => [product, ...prev]);
            }}

          />
        </Dialog>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  _data: state.pos.data,
  _stores: state.pos.stores,
  _store: state.pos.defStore,
  _authUser: state.pos.authUser,
});

const mapActionToProps = {
  _post: actions.post,
  _put: actions.put,
  _getById: actions.getById,
  _getByObj: actions.getByObj,
  _get: actions.get,
  _clear: actions.clear,
};

export default connect(mapStateToProps, mapActionToProps)(AddMultPurch);
